/* eslint-disable camelcase */
import getSessionContext from 'src/utils/context/getSessionContext';
import { make } from 'vuex-pathify';
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker';
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker';
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker';
import getRecords from 'src/utils/entityOperations/getRecords';
const remoteEntityName = 'ci.rule_condition_types';
const state = Object.assign({}, makeTableCommonState());
const getters = Object.assign(Object.assign({}, makeTableCommonGetters({ remoteEntityName })), { pageTitle: () => 'Rule condition types', controlledActions: () => {
        return {
            create: -1,
            fetch: [1, 309],
            update: -1,
            delete: -1,
            downloadList: -1,
            uploadList: -1
        };
    }, controllerDefaultParams: () => {
        return {
            fetch: { org_id: getSessionContext().org_id }
        };
    }, columns: () => {
        return [
            { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreating: true, isNumeric: true },
            { name: 'name', label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true },
            { name: 'value_type', label: 'Value Type', field: 'value_type', inlineEdit: true, align: 'left', required: true },
            { name: 'reference_entity', label: 'Reference Entity', field: 'reference_entity', inlineEdit: true, align: 'left', required: true },
            { name: 'available_predicates', label: 'Available Predicates', field: 'available_predicates', inlineEdit: true, align: 'left', required: true },
            { name: 'scope_org_id', label: 'Scope Org ID', field: 'scope_org_id', inlineEdit: true, align: 'left', required: true, isNumeric: true },
            { name: 'scope_app_id', label: 'Scope App ID', field: 'scope_app_id', inlineEdit: true, align: 'left', required: true, isNumeric: true }
        ];
    } });
const mutations = make.mutations(state);
const namespaced = true;
const actions = Object.assign({}, makeTableCommonActions());
export default { state, actions, mutations, getters, namespaced };
export function getAvailablePredicatesOfRuleConditionType(ruleConditionTypeId) {
    var _a;
    const ruleConditionTypes = getRecords('ci.rule_condition_types') || [];
    return ((_a = ruleConditionTypes.find((ruleConditionType) => ruleConditionType.id === ruleConditionTypeId)) === null || _a === void 0 ? void 0 : _a.available_predicates) || [];
}
